module.exports = __webpack_public_path__ + "static/media/james.f8039822.jpg";